import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Megaphone } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MarketingConsentToggle = () => {
  const { token } = useAuth();
  const [consent, setConsent] = useState(null);
  const [busy, setBusy] = useState(false);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/marketing-consent/me`, { headers }).then(({ data }) => setConsent(data)).catch(() => setConsent(null));
  }, [token]);

  if (!consent?.applicable) return null;

  const toggle = async (checked) => {
    setBusy(true);
    try {
      const choice = checked ? 'accepted' : 'refused';
      const { data } = await axios.post(`${API}/marketing-consent`, { choice, source: 'profile' }, { headers });
      setConsent({ ...consent, status: data.status, answered_at: data.answered_at });
      toast.success(checked ? 'Consentement enregistré.' : 'Consentement retiré.');
    } catch (error) {
      toast.error('Ton choix n’a pas pu être enregistré.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-8 rounded border border-zinc-800 bg-[#18181B] p-6" data-testid="marketing-consent-section">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="mb-2 flex items-center gap-2 text-xl font-bold text-white"><Megaphone className="h-5 w-5 text-[#FFD60A]" />Offres commerciales</h2>
          <p className="text-sm text-zinc-400">{consent.text}</p>
          <p className="mt-2 text-xs text-zinc-500" data-testid="marketing-consent-status">
            {consent.status === 'accepted' ? 'Accepté' : consent.status === 'refused' ? 'Refusé' : 'Pas encore de réponse'}
            {consent.answered_at ? ` le ${new Date(consent.answered_at).toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })}` : ''}
          </p>
        </div>
        <Switch checked={consent.status === 'accepted'} disabled={busy} onCheckedChange={toggle} data-testid="marketing-consent-switch" />
      </div>
    </div>
  );
};
